import { render } from "./comasideadmin.vue?vue&type=template&id=4aa4a66f&scoped=true"
import script from "./comasideadmin.vue?vue&type=script&lang=js"
export * from "./comasideadmin.vue?vue&type=script&lang=js"

import "./comasideadmin.vue?vue&type=style&index=0&id=4aa4a66f&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa4a66f"]])

export default __exports__